enum HtmlExtractionDialogFields {
	ERROR = 'error',
	DPI = 'dpi',
	PAGERANGE = 'pagerange'
}

export default HtmlExtractionDialogFields;